// Marcação simples: "## " título de seção, "### " subtítulo, "- " item de lista, demais linhas = parágrafo.
// Links: [texto](/rota). E-mails e URLs viram links automaticamente.

export const LEGAL_UPDATED_AT = "29 de outubro de 2026";

export const LEGAL_PAGES = {
  "termos-de-uso": {
    title: "Termos de Uso",
    body: `## 1. Apresentação
Bem-vindo à Connectick.
A Connectick é uma plataforma digital destinada à divulgação de eventos, à comercialização de ingressos e à disponibilização de ferramentas para produtores de eventos.
Por meio da plataforma, os usuários podem consultar eventos, adquirir ingressos e acessar informações relacionadas aos pedidos. Os produtores podem utilizar as funcionalidades disponibilizadas para divulgar eventos, acompanhar vendas e administrar seus ingressos.
Ao utilizar a Connectick, o usuário declara que leu estes Termos de Uso e compreende as regras aplicáveis à utilização da plataforma, sem prejuízo dos direitos garantidos pela legislação brasileira.
## 2. Cadastro e informações fornecidas
Os usuários devem fornecer informações verdadeiras, completas e atualizadas quando realizarem cadastros ou compras.
Cada usuário é responsável pela segurança de suas credenciais e pelas atividades realizadas em sua conta, ressalvadas as hipóteses de falha de segurança ou responsabilidade atribuível à plataforma.
A Connectick poderá solicitar informações adicionais quando necessárias para a segurança da conta, a prevenção de fraudes ou o cumprimento de obrigações legais.
## 3. Compra de ingressos
Antes de concluir uma compra, o comprador deve conferir as informações apresentadas na página do evento, incluindo:
- Nome e descrição do evento.
- Data, horário e local.
- Atrações anunciadas.
- Tipo e lote do ingresso.
- Preço e eventuais taxas.
- Classificação indicativa e condições de acesso.
- Outras informações relevantes disponibilizadas pelo produtor.
A confirmação da compra depende da conclusão do pedido e da confirmação do pagamento pelo sistema utilizado.
O ingresso será disponibilizado conforme os procedimentos da plataforma e as informações fornecidas pelo comprador.
## 4. Responsabilidades dos produtores
Os produtores são responsáveis pelas informações fornecidas sobre seus eventos, incluindo programação, atrações, estrutura, local, capacidade, autorizações, regras de acesso e realização do evento.
Também cabe ao produtor cumprir as obrigações legais relacionadas à organização do evento e prestar as informações necessárias aos compradores.
A Connectick atuará conforme os serviços que disponibiliza e as obrigações legais e contratuais que lhe sejam aplicáveis.
## 5. Pagamentos, taxas e repasses
Os pagamentos serão processados pelos meios disponibilizados no momento da compra.
Poderão ser cobradas taxas de serviço, desde que suas condições sejam apresentadas de maneira clara antes da finalização do pedido.
Os valores das vendas poderão ser recebidos inicialmente por meio da estrutura de pagamento utilizada pela Connectick e posteriormente repassados ao produtor, conforme os contratos, os prazos operacionais e as regras aplicáveis.
As condições detalhadas estão descritas na [Política de Pagamentos, Taxas e Repasses](/politica-de-pagamentos).
## 6. Cancelamentos e reembolsos
As solicitações de cancelamento e reembolso serão tratadas conforme a legislação brasileira, as condições do evento e a [Política de Reembolso e Cancelamento](/reembolso-e-cancelamento).
O produtor será responsável por analisar, autorizar e realizar os reembolsos relacionados ao seu evento, conforme as regras aplicáveis e os procedimentos operacionais da plataforma.
Essa distribuição de responsabilidades não exclui eventuais obrigações legais próprias da Connectick.
## 7. Uso adequado da plataforma
É proibido utilizar a Connectick para:
- Realizar fraudes ou tentativas de fraude.
- Divulgar eventos inexistentes ou enganosos.
- Falsificar, duplicar ou adulterar ingressos.
- Utilizar dados de terceiros sem autorização.
- Tentar acessar contas ou informações sem permissão.
- Interferir no funcionamento da plataforma.
- Praticar atividades ilícitas ou violar direitos de terceiros.
A Connectick poderá investigar ocorrências e adotar medidas proporcionais, respeitando a legislação aplicável.
## 8. Disponibilidade dos serviços
A Connectick poderá realizar manutenções, atualizações e ajustes técnicos para manter o funcionamento da plataforma.
Em caso de falhas ou indisponibilidade, serão adotadas medidas razoáveis para restabelecer os serviços, sem prejuízo dos direitos legalmente assegurados aos usuários.
## 9. Privacidade e proteção de dados
O tratamento dos dados pessoais está descrito na [Política de Privacidade](/politica-de-privacidade), que integra as regras de utilização da plataforma.
## 10. Alterações dos termos
Estes Termos de Uso poderão ser atualizados para refletir alterações legais, operacionais ou tecnológicas.
A versão vigente ficará disponível nesta página, com sua data de atualização. Quando necessário, a Connectick solicitará novo aceite.
## 11. Legislação aplicável
Estes termos são regidos pela legislação brasileira, respeitados os direitos dos consumidores e as demais normas obrigatórias.
## 12. Contato
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229
Site: https://connectick.online`,
  },

  "politica-de-privacidade": {
    title: "Política de Privacidade",
    body: `## 1. Introdução
A Connectick respeita a privacidade dos usuários e busca tratar os dados pessoais de maneira transparente e segura.
Esta Política de Privacidade explica quais informações poderão ser tratadas, para quais finalidades poderão ser utilizadas e como os titulares podem exercer seus direitos previstos na Lei Geral de Proteção de Dados Pessoais — LGPD (Lei nº 13.709/2018).
## 2. Quais dados podem ser tratados
Conforme a utilização da plataforma, poderão ser tratados:
- Nome e sobrenome.
- Endereço de e-mail.
- Número de telefone.
- Informações necessárias à identificação de pedidos e ingressos.
- Histórico de compras e informações relacionadas aos eventos.
- Registros de atendimento.
- Dados técnicos de acesso, como endereço IP, navegador e dispositivo.
- Registros necessários à segurança e à prevenção de fraudes.
- Informações necessárias ao tratamento de cancelamentos, reembolsos e contestações.
Os dados efetivamente coletados dependerão das funcionalidades utilizadas.
A Connectick não deverá declarar que armazena dados completos de cartões bancários se essas informações forem processadas diretamente pelo prestador de pagamento.
## 3. Para que os dados são utilizados
Os dados poderão ser utilizados para:
- Processar pedidos e compras.
- Emitir e disponibilizar ingressos.
- Confirmar pagamentos.
- Administrar pedidos e solicitações de suporte.
- Processar solicitações de cancelamento e reembolso.
- Prestar atendimento aos usuários.
- Cumprir obrigações legais e regulatórias.
- Prevenir fraudes e proteger a plataforma.
- Melhorar o funcionamento dos serviços.
- Enviar comunicações necessárias à execução de uma compra.
- Enviar comunicações promocionais quando houver base legal adequada.
## 4. Bases legais
O tratamento dos dados será realizado com fundamento na hipótese legal aplicável a cada finalidade, podendo incluir execução de contrato, cumprimento de obrigação legal ou regulatória, exercício regular de direitos, legítimo interesse, consentimento ou outras bases previstas na LGPD.
Quando o tratamento depender de consentimento, este deverá ser solicitado de maneira adequada e poderá ser revogado nos termos da legislação.
## 5. Compartilhamento de dados
Os dados poderão ser compartilhados, quando necessário, com:
- Produtores dos eventos, para administração dos ingressos e realização do evento.
- Prestadores de serviços de pagamento.
- Provedores de hospedagem e infraestrutura tecnológica.
- Ferramentas de comunicação e atendimento.
- Prestadores de segurança e prevenção a fraudes.
- Autoridades públicas, quando houver obrigação ou fundamento legal.
O compartilhamento deverá respeitar a finalidade do tratamento, a necessidade dos dados e os direitos dos titulares.
## 6. Dados compartilhados com produtores
Quando uma pessoa compra um ingresso, determinados dados poderão ser disponibilizados ao produtor responsável pelo evento para viabilizar a entrada, administrar a compra, prestar informações e cumprir obrigações relacionadas à realização do evento.
O produtor deverá utilizar os dados recebidos de forma legítima e compatível com a finalidade informada, observando a legislação de proteção de dados.
## 7. Pagamentos e informações financeiras
As compras poderão ser processadas por prestadores de pagamento integrados à plataforma.
Os dados financeiros serão tratados conforme a arquitetura efetiva da integração e as regras dos prestadores envolvidos.
A Connectick poderá tratar informações relacionadas ao pedido, ao status do pagamento, ao repasse, ao cancelamento e ao reembolso na medida necessária à operação da plataforma.
## 8. Segurança e conservação
A Connectick buscará adotar medidas técnicas e administrativas adequadas para proteger os dados contra acessos não autorizados, perda, alteração ou divulgação indevida.
Os dados serão conservados pelo período necessário às finalidades do tratamento e às obrigações legais aplicáveis.
A eliminação poderá ocorrer quando cabível, respeitadas as hipóteses legais de conservação.
## 9. Direitos dos titulares
Nos termos da LGPD, o titular poderá solicitar, conforme aplicável:
- Confirmação da existência de tratamento.
- Acesso aos dados pessoais.
- Correção de dados incompletos, inexatos ou desatualizados.
- Anonimização, bloqueio ou eliminação de dados nas hipóteses legais.
- Informações sobre compartilhamento.
- Portabilidade, quando aplicável.
- Revogação do consentimento, quando essa for a base utilizada.
- Demais direitos previstos na legislação.
As solicitações poderão ser encaminhadas para connectickbr@gmail.com.
A Connectick poderá solicitar informações razoáveis para confirmar a identidade do solicitante e proteger os dados contra acesso indevido.
## 10. Comunicações promocionais
As comunicações promocionais serão realizadas conforme a legislação aplicável e a base legal pertinente.
Quando aplicável, o usuário poderá solicitar a interrupção dessas comunicações pelos mecanismos disponibilizados na mensagem ou pelos canais oficiais.
As mensagens estritamente necessárias à execução de pedidos poderão continuar sendo enviadas quando houver fundamento legal para isso.
## 11. Cookies e tecnologias semelhantes
A plataforma poderá utilizar cookies e tecnologias semelhantes para manter funcionalidades essenciais, guardar preferências, analisar o uso do site e medir campanhas publicitárias.
As tecnologias efetivamente utilizadas deverão ser identificadas e configuradas de acordo com a legislação e as escolhas dos usuários.
Mais informações estão disponíveis na [Política de Cookies](/politica-de-cookies).
## 12. Atualizações
Esta política poderá ser atualizada para refletir mudanças nos serviços ou nas obrigações legais.
A versão vigente será publicada nesta página.
## 13. Contato sobre privacidade
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229`,
  },

  "reembolso-e-cancelamento": {
    title: "Política de Reembolso e Cancelamento",
    body: `## 1. Objetivo
Esta política apresenta as orientações para solicitações de cancelamento, reembolso e tratamento de ocorrências relacionadas aos ingressos comercializados por meio da Connectick.
## 2. Direito de arrependimento
Nas compras realizadas fora do estabelecimento comercial, será observado o direito de arrependimento previsto no artigo 49 do Código de Defesa do Consumidor, quando aplicável.
O prazo legal e as condições para exercício desse direito serão observados conforme a legislação aplicável ao caso concreto.
A emissão do ingresso ou a proximidade da data do evento não serão utilizadas, isoladamente, para afastar direitos legalmente assegurados ao consumidor.
## 3. Como solicitar um cancelamento
O comprador poderá solicitar o cancelamento por meio dos canais oficiais de atendimento.
Para facilitar a identificação do pedido, deverá informar, quando disponível:
- Nome utilizado na compra.
- E-mail cadastrado no pedido.
- Número do pedido.
- Nome do evento.
- Descrição da solicitação.
Não envie senhas, códigos de segurança de cartões ou números completos de cartões bancários.
## 4. Responsabilidade do produtor pelo reembolso
O produtor responsável pelo evento é responsável por analisar a solicitação, autorizar o reembolso quando cabível e realizar os procedimentos financeiros necessários, conforme a legislação, as condições anunciadas e os contratos aplicáveis.
A Connectick poderá disponibilizar os recursos operacionais necessários para registrar a solicitação, encaminhar informações ao produtor e viabilizar o procedimento de acordo com o sistema utilizado.
A responsabilidade atribuída ao produtor não elimina eventuais obrigações legais próprias da Connectick.
## 5. Eventos cancelados, adiados ou alterados
Em caso de cancelamento, adiamento ou alteração relevante do evento, o produtor deverá comunicar as informações pertinentes e orientar os compradores sobre os procedimentos aplicáveis.
As opções disponíveis serão definidas conforme a legislação, as condições anunciadas e as circunstâncias do evento.
Os compradores poderão entrar em contato com a Connectick para obter orientações sobre o encaminhamento da solicitação.
## 6. Processamento do reembolso
O procedimento financeiro dependerá do meio de pagamento utilizado, das regras do prestador de pagamento e da situação do pedido.
Quando os valores já tiverem sido repassados ao produtor, poderá ser necessária a atuação financeira do próprio produtor para viabilizar o reembolso.
Quando os valores ainda estiverem na estrutura de recebimento utilizada pela Connectick, o procedimento seguirá as regras contratuais e operacionais aplicáveis.
A forma de processamento e o prazo estimado deverão ser informados ao comprador de acordo com as condições efetivamente disponíveis.
Não será prometido um prazo que não esteja confirmado pelo prestador de pagamento.
## 7. Taxas relacionadas ao pedido
O tratamento de taxas e eventuais encargos em caso de cancelamento ou reembolso seguirá a legislação aplicável e as condições informadas no momento da compra.
Nenhuma disposição desta política poderá ser interpretada como autorização para reter valores quando a legislação determinar sua devolução.
## 8. Compras não reconhecidas e contestações
Caso o comprador não reconheça uma compra, deverá entrar em contato pelos canais oficiais para que a ocorrência seja analisada.
A Connectick e o produtor poderão verificar os registros disponíveis, como informações do pedido, confirmações de pagamento, comunicações e registros de validação do ingresso.
O comparecimento ao evento ou a validação de um ingresso poderá ser considerado como elemento de análise, mas não será tratado isoladamente como prova conclusiva de fraude.
As informações serão tratadas respeitando a legislação de proteção de dados.
## 9. Como acompanhar a solicitação
O comprador deverá acompanhar as comunicações encaminhadas pelos canais utilizados no atendimento.
Caso sejam necessárias informações adicionais, o suporte poderá solicitá-las para identificar o pedido e encaminhar a análise.
## 10. Canais de atendimento
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229
Site: https://connectick.online`,
  },

  "politica-de-pagamentos": {
    title: "Política de Pagamentos, Taxas e Repasses",
    body: `## 1. Objetivo
Esta política explica as condições gerais dos pagamentos realizados por compradores, as taxas aplicáveis e o fluxo de repasse dos valores relacionados às vendas de ingressos na Connectick.
## 2. Meios de pagamento
Os meios de pagamento disponíveis serão apresentados durante a compra.
A confirmação do pedido dependerá do processamento e da confirmação do pagamento pelo sistema utilizado.
A disponibilidade de cada modalidade poderá variar conforme a configuração da plataforma e as condições do prestador de pagamento.
## 3. Transparência das taxas
As taxas aplicáveis à compra deverão ser exibidas de maneira clara antes da conclusão do pedido.
O comprador poderá consultar o valor do ingresso, as taxas adicionais e o valor total antes de confirmar a compra.
Para os produtores, as taxas e condições comerciais serão aquelas previstas no contrato ou nas condições de contratação aplicáveis.
## 4. Fluxo financeiro das vendas
Na operação prevista da Connectick, os valores das vendas poderão ser recebidos inicialmente por meio da estrutura de pagamento utilizada pela plataforma e posteriormente repassados ao produtor responsável pelo evento.
O processamento efetivo dependerá da integração financeira contratada e das regras aplicáveis ao prestador de pagamento.
O recebimento inicial pela estrutura da Connectick não significa que os valores das vendas sejam receita própria da plataforma. A classificação contábil e tributária deverá refletir a operação real e os contratos existentes.
## 5. Repasses aos produtores
Os valores serão repassados conforme as condições contratuais, a confirmação dos pagamentos, as taxas aplicáveis e os prazos efetivamente definidos para a operação.
O produtor deverá fornecer as informações necessárias para a realização dos repasses.
O prazo e os critérios aplicáveis deverão ser informados ao produtor de acordo com o contrato vigente.
Não será anunciado prazo fixo sem que esteja confirmado pela operação financeira e pelos contratos aplicáveis.
## 6. Taxas e descontos
Poderão ser aplicadas as taxas expressamente previstas nas condições comerciais ou contratuais.
Eventuais descontos, ajustes ou compensações deverão ter fundamento contratual ou legal e ser demonstráveis ao produtor.
A Connectick não deverá aplicar cobranças não informadas ou não autorizadas pelas condições aplicáveis.
## 7. Cancelamentos, estornos e contestações
Os cancelamentos e reembolsos serão tratados conforme a [Política de Reembolso e Cancelamento](/reembolso-e-cancelamento).
As contestações de pagamento e os estornos seguirão as regras do prestador de pagamento, os contratos e a legislação aplicável.
O produtor deverá colaborar com a análise das solicitações relacionadas ao seu evento.
A atribuição de responsabilidades financeiras dependerá das circunstâncias do caso, das obrigações legais e dos contratos aplicáveis.
## 8. Segurança dos pagamentos
A Connectick poderá adotar medidas de verificação e prevenção a fraudes para proteger os usuários e a plataforma.
O usuário nunca deverá compartilhar senhas ou códigos de segurança bancários com pessoas que se apresentem como representantes da Connectick.
## 9. Atendimento financeiro
Para dúvidas sobre pedidos, taxas ou repasses, entre em contato:
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229`,
  },

  "regras-dos-ingressos": {
    title: "Regras de Compra e Utilização dos Ingressos",
    body: `## 1. Antes de comprar
Antes de finalizar a compra, confira cuidadosamente as informações divulgadas na página do evento.
Verifique a data, o horário, o endereço, as atrações, a classificação indicativa, o tipo de ingresso, o lote, as condições de acesso e o valor total.
Em caso de dúvida sobre a programação ou a estrutura do evento, entre em contato com o produtor ou com os canais de atendimento.
## 2. Confirmação da compra
A compra será confirmada conforme o processamento do pedido e a confirmação do pagamento.
O comprador deverá utilizar informações de contato válidas para receber as comunicações relacionadas ao pedido.
## 3. Recebimento do ingresso
Após a confirmação do pagamento, o ingresso será disponibilizado pelo meio informado na plataforma, como e-mail ou área de pedidos, conforme as funcionalidades existentes.
Caso não encontre o ingresso, verifique a pasta de spam e confirme se o endereço de e-mail informado está correto.
Se o problema persistir, entre em contato com o suporte.
## 4. QR Code e validação
Quando o ingresso utilizar QR Code, ele será validado pelos mecanismos disponibilizados para o evento.
O comprador deverá apresentar o ingresso conforme as instruções divulgadas pelo produtor.
A equipe responsável pelo acesso poderá verificar a validade do ingresso e se ele já foi utilizado.
## 5. Proteção do ingresso
O comprador deve proteger seu ingresso e evitar publicar ou compartilhar seu QR Code em ambientes públicos.
Caso outra pessoa tenha acesso ao código e o utilize indevidamente, poderá haver dificuldade para comprovar a titularidade da entrada, conforme as circunstâncias e os registros disponíveis.
## 6. Ingressos duplicados ou inválidos
Ingressos falsificados, adulterados, duplicados ou já utilizados poderão ser recusados conforme as condições do evento e os procedimentos de validação.
As ocorrências serão analisadas individualmente, respeitando os direitos do comprador e as evidências disponíveis.
## 7. Dados da compra
O comprador deverá manter seus dados de contato atualizados e apresentar as informações necessárias para localizar o pedido quando solicitar atendimento.
Nunca informe senhas ou códigos de segurança de cartões para validar um ingresso.
## 8. Regras do evento
O acesso está sujeito às regras divulgadas pelo produtor, incluindo classificação indicativa, documentos necessários, restrições legais e condições de segurança.
As regras específicas deverão ser informadas na página do evento sempre que forem relevantes para a compra.
## 9. Cancelamentos e reembolsos
Os procedimentos de cancelamento e reembolso estão descritos na [Política de Reembolso e Cancelamento](/reembolso-e-cancelamento).
Nada nestas regras elimina direitos assegurados pela legislação brasileira.
## 10. Atendimento
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229`,
  },

  "termos-produtores": {
    title: "Termos e Condições para Produtores",
    body: `## 1. Objetivo
Estes termos estabelecem as condições gerais para utilização da Connectick por produtores que desejam divulgar eventos, comercializar ingressos e utilizar as ferramentas disponibilizadas pela plataforma.
## 2. Cadastro do produtor
O produtor deverá fornecer informações verdadeiras, completas e atualizadas.
A Connectick poderá solicitar documentos e informações adicionais quando necessários para identificação, segurança, prevenção a fraudes ou cumprimento de obrigações legais.
## 3. Responsabilidade pela realização do evento
O produtor é responsável pela organização e realização do evento, incluindo, conforme aplicável:
- Informações publicadas na página do evento.
- Contratação e pagamento de atrações.
- Local, estrutura e capacidade.
- Segurança e equipe operacional.
- Autorizações, licenças e demais requisitos legais.
- Classificação indicativa e condições de acesso.
- Comunicação de alterações aos compradores.
- Cumprimento das obrigações legais relacionadas ao evento.
O produtor deverá garantir que possui autorização para utilizar marcas, imagens, textos e demais materiais publicados.
## 4. Informações e divulgação
O produtor deverá revisar as informações do evento antes de publicá-lo.
Alterações de data, horário, local, atrações, preços ou condições relevantes deverão ser atualizadas na plataforma e comunicadas aos compradores quando necessário.
A divulgação não poderá conter informações falsas, enganosas ou que violem direitos de terceiros.
## 5. Taxas e condições comerciais
As taxas e condições aplicáveis serão aquelas informadas na contratação ou previstas no contrato entre as partes.
O produtor deverá verificar as condições comerciais antes de disponibilizar os ingressos para venda.
Não serão aplicadas condições financeiras diferentes das contratadas sem fundamento e comunicação adequados.
## 6. Recebimento e repasse dos valores
Na operação prevista, os valores das vendas poderão ser recebidos inicialmente pela estrutura de pagamento utilizada pela Connectick e posteriormente repassados ao produtor.
O repasse dependerá da confirmação dos pagamentos, das condições contratuais, das taxas aplicáveis e das regras do prestador de pagamento.
Os prazos e procedimentos serão aqueles efetivamente acordados para a operação.
## 7. Cancelamentos e reembolsos
O produtor é responsável por analisar as solicitações de reembolso, autorizar os pedidos quando cabíveis e realizar os procedimentos financeiros correspondentes, respeitando a legislação e as condições anunciadas.
Em caso de cancelamento, adiamento ou alteração relevante, o produtor deverá comunicar a Connectick com a maior brevidade possível e fornecer as informações necessárias para orientar os compradores.
A Connectick poderá prestar suporte operacional e encaminhar solicitações, conforme as funcionalidades existentes.
A distribuição contratual de responsabilidades não afasta eventuais obrigações legais próprias da Connectick.
## 8. Estornos e contestações
O produtor deverá colaborar com a análise de contestações relacionadas às vendas de seu evento, fornecendo documentos e registros legítimos quando solicitados.
A atribuição de custos, estornos e demais consequências financeiras observará a legislação, as regras do prestador de pagamento e o contrato aplicável.
## 9. Dados pessoais dos compradores
O produtor deverá utilizar os dados pessoais recebidos por meio da plataforma apenas para finalidades legítimas e compatíveis com a coleta.
É proibido vender, divulgar indevidamente ou utilizar dados dos compradores para finalidades incompatíveis com a legislação.
O envio de publicidade deverá observar a LGPD e os direitos dos titulares.
## 10. Atividades proibidas
O produtor não poderá utilizar a Connectick para promover eventos fictícios, realizar fraudes, falsificar ingressos, violar direitos de terceiros ou praticar atividades ilícitas.
## 11. Segurança e suspensão de acesso
Diante de indícios fundamentados de fraude, uso indevido ou violação contratual, a Connectick poderá realizar verificações e adotar medidas proporcionais, respeitando a legislação e os direitos das partes.
## 12. Aceite dos termos
Ao utilizar as funcionalidades destinadas a produtores, o usuário declara que teve acesso a estes termos e que deverá cumprir as condições aplicáveis.
Quando exigido, o sistema deverá registrar o aceite da versão vigente, a data e a identificação da conta.
## 13. Contato
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229`,
  },

  "politica-de-cookies": {
    title: "Política de Cookies",
    body: `## 1. O que são cookies
Cookies são pequenos arquivos ou identificadores que podem ser armazenados no navegador ou dispositivo do usuário para permitir o funcionamento de sites, guardar preferências e compreender como os serviços são utilizados.
A Connectick poderá utilizar cookies e tecnologias semelhantes conforme as funcionalidades e ferramentas efetivamente implementadas.
## 2. Categorias de cookies
### Cookies essenciais
São utilizados para permitir o funcionamento básico e a segurança da plataforma, incluindo recursos necessários à navegação e às funcionalidades solicitadas pelo usuário.
### Cookies de preferências
Podem guardar escolhas do usuário para proporcionar uma experiência mais consistente, quando esses recursos estiverem implementados.
### Cookies de estatísticas
Podem ajudar a compreender como os usuários navegam no site e quais funcionalidades são mais utilizadas.
### Cookies de marketing
Podem ser utilizados para medir campanhas publicitárias e compreender a interação dos usuários com anúncios, quando essas ferramentas estiverem implementadas.
## 3. Controle de cookies
Quando exigido pela legislação, os cookies não essenciais deverão depender da escolha ou do consentimento adequado do usuário antes de serem ativados.
O usuário deverá ter acesso a opções claras para aceitar, rejeitar ou configurar cookies não essenciais.
A escolha poderá ser alterada posteriormente por meio das configurações disponibilizadas no site.
## 4. Cookies de terceiros
Algumas funcionalidades poderão utilizar serviços de terceiros, como ferramentas de análise ou publicidade.
Esses serviços poderão tratar informações conforme suas próprias políticas, sem prejuízo das obrigações aplicáveis à Connectick.
## 5. Como gerenciar cookies no navegador
O usuário também poderá gerenciar cookies pelas configurações do navegador. A desativação de determinados cookies poderá afetar o funcionamento de algumas funcionalidades.
## 6. Atualizações
Esta política poderá ser atualizada conforme as ferramentas utilizadas e as exigências legais.
## 7. Contato
Dúvidas sobre privacidade e cookies poderão ser encaminhadas para:
connectickbr@gmail.com`,
  },

  "ajuda": {
    title: "Central de Ajuda e Atendimento",
    body: `## 1. Como podemos ajudar?
A Central de Ajuda da Connectick reúne orientações para compradores e produtores de eventos.
Para um atendimento mais rápido, informe o assunto da solicitação e os dados necessários para localizar o pedido ou a conta.
## 2. Comprei um ingresso. Como recebo?
Após a confirmação do pagamento, consulte o e-mail informado durante a compra e verifique também a pasta de spam.
Se a plataforma disponibilizar uma área de pedidos, você poderá consultar o ingresso por esse recurso.
Se não encontrar o ingresso, entre em contato com o atendimento informando o e-mail utilizado na compra e o número do pedido, quando disponível.
## 3. Meu pagamento foi aprovado, mas não recebi o ingresso
Verifique se o pagamento foi confirmado e se o endereço de e-mail está correto.
Se o ingresso continuar indisponível, entre em contato pelos canais oficiais para que o pedido seja localizado e analisado.
## 4. Como solicito um cancelamento ou reembolso?
Consulte a página [Reembolso e Cancelamento](/reembolso-e-cancelamento).
Envie sua solicitação com o nome utilizado na compra, o e-mail do pedido, o evento e o número do pedido, quando disponível.
O produtor responsável pelo evento deverá analisar, autorizar e realizar o reembolso quando cabível, respeitando a legislação aplicável. A Connectick poderá auxiliar no encaminhamento operacional da solicitação.
## 5. O evento foi cancelado ou alterado
Consulte as informações oficiais do evento e entre em contato com o atendimento se precisar de orientações sobre o pedido.
O produtor deverá informar as alterações relevantes e cumprir as obrigações aplicáveis aos compradores.
## 6. Meu ingresso não está validando
Confira se está apresentando o ingresso correto para o evento e se o código está legível.
Se o problema persistir, procure a equipe responsável pelo acesso ou entre em contato com o suporte, apresentando as informações do pedido.
Não publique seu QR Code em redes sociais ou grupos públicos.
## 7. Não reconheço uma compra
Entre em contato com o atendimento para que a ocorrência seja analisada.
Nunca envie senhas, códigos bancários ou o código de segurança do cartão.
## 8. Sou produtor. Como acompanho minhas vendas?
Acesse o painel do produtor, caso essa funcionalidade esteja disponível para sua conta, e consulte os relatórios e pedidos.
Se tiver problemas de acesso, entre em contato pelo canal oficial.
## 9. Como funcionam os repasses aos produtores?
Os repasses seguem as condições contratuais, a confirmação dos pagamentos, os prazos aplicáveis e as regras do prestador de pagamento.
Em caso de dúvida sobre um repasse específico, informe os dados do evento e do período relacionado à solicitação.
## 10. Canais oficiais
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229
Site: https://connectick.online
Não forneça senhas ou códigos de segurança a pessoas que afirmem representar a Connectick.`,
  },

  "politica-antifraude": {
    title: "Política Antifraude e Uso Proibido",
    body: `## 1. Objetivo
A Connectick busca proteger compradores, produtores e demais usuários contra fraudes, falsificações, acessos não autorizados e utilização indevida da plataforma.
## 2. Condutas proibidas
É proibido:
- Criar eventos fictícios com o objetivo de receber pagamentos indevidos.
- Utilizar documentos ou identidades de terceiros sem autorização.
- Realizar compras utilizando meios de pagamento sem autorização.
- Falsificar, adulterar ou duplicar ingressos.
- Tentar utilizar ingressos já validados.
- Acessar contas ou informações sem autorização.
- Manipular pedidos, registros ou relatórios.
- Explorar falhas de segurança.
- Divulgar informações falsas para prejudicar usuários ou produtores.
- Utilizar a plataforma para atividades ilícitas.
## 3. Monitoramento e análise
A Connectick poderá analisar informações técnicas, registros de pedidos, pagamentos, comunicações e validações de ingressos na medida necessária à segurança, à prevenção de fraudes e ao cumprimento de obrigações legais.
O tratamento deverá respeitar a [Política de Privacidade](/politica-de-privacidade) e a legislação aplicável.
## 4. Medidas de segurança
Quando houver indícios fundamentados de irregularidade, a Connectick poderá solicitar esclarecimentos, realizar verificações, restringir temporariamente funcionalidades ou adotar outras medidas proporcionais.
As medidas deverão considerar as circunstâncias do caso e respeitar os direitos dos envolvidos.
## 5. Contestações de pagamento
As contestações serão analisadas individualmente, considerando as informações disponíveis e as regras do prestador de pagamento.
Registros de compra, comunicação, utilização do ingresso e validação poderão ser considerados em conjunto.
Uma contestação, por si só, não será tratada automaticamente como prova de fraude.
## 6. Cooperação com autoridades
Quando houver fundamento legal, a Connectick poderá fornecer informações às autoridades competentes e cooperar com procedimentos de investigação, respeitando os limites legais aplicáveis.
## 7. Como comunicar uma suspeita
Caso identifique uma atividade suspeita, entre em contato pelos canais oficiais e forneça informações suficientes para que a ocorrência possa ser analisada.
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229`,
  },

  "contato": {
    title: "Fale com a Connectick",
    body: `A Connectick disponibiliza canais de contato para dúvidas sobre compras, ingressos, eventos, pagamentos, repasses e utilização da plataforma.
## Dados da empresa
Nome comercial: Connectick
Razão social informada: Connectickbrasil
CNPJ: 57.473.540/0001-00
Endereço: Rua Rubia Mara Barbosa, nº 10, bairro Diamante, CEP 30660-298, Belo Horizonte, Minas Gerais, Brasil.
## Canais de atendimento
E-mail: connectickbr@gmail.com
WhatsApp: (31) 97131-9229
Site oficial: https://connectick.online
## Para agilizar o atendimento
Em solicitações relacionadas a compras, informe o e-mail utilizado no pedido, o nome do evento e o número do pedido, quando disponível.
Não envie senhas, números completos de cartões bancários ou códigos de segurança.
## Informações legais
Consulte também:
- [Termos de Uso](/termos-de-uso)
- [Política de Privacidade](/politica-de-privacidade)
- [Política de Reembolso e Cancelamento](/reembolso-e-cancelamento)
- [Política de Pagamentos, Taxas e Repasses](/politica-de-pagamentos)
- [Regras de Compra e Utilização dos Ingressos](/regras-dos-ingressos)
- [Termos e Condições para Produtores](/termos-produtores)
- [Política de Cookies](/politica-de-cookies)
- [Central de Ajuda](/ajuda)
- [Política Antifraude e Uso Proibido](/politica-antifraude)`,
  },
};

export const FOOTER_GROUPS = [
  { title: "Informações legais", links: [
    ["Termos de Uso", "/termos-de-uso"], ["Política de Privacidade", "/politica-de-privacidade"],
    ["Política de Cookies", "/politica-de-cookies"], ["Política Antifraude e Uso Proibido", "/politica-antifraude"],
  ] },
  { title: "Compradores", links: [
    ["Reembolso e Cancelamento", "/reembolso-e-cancelamento"], ["Regras de Compra e Utilização dos Ingressos", "/regras-dos-ingressos"],
    ["Central de Ajuda", "/ajuda"],
  ] },
  { title: "Produtores", links: [
    ["Termos e Condições para Produtores", "/termos-produtores"], ["Política de Pagamentos, Taxas e Repasses", "/politica-de-pagamentos"],
  ] },
  { title: "Contato", links: [["Fale com a Connectick", "/contato"]] },
];
